import React, { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import HotSeatWinnerContent from "./HotSeatWinnerContent";

const Window = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  overflow: hidden;
  pointer-events: none;
  display: none;
  opacity: var(--reveal-opacity, 0);
  .content {
    position: absolute;
    inset: 0;
    opacity: var(--content-opacity, 0);
  }
  .content * { animation: none !important; transition: none !important; }
  /* The heading enters once on the result route; do not show it before its zoom. */
  .content .royal-information, .content .royal-trophy { visibility: hidden; }
`;

// The 3D camera enters the actual LCD first. Then the full-size result fades in.
export default forwardRef(function WinnerScreenReveal({ winner, showWinner }, ref) {
  const element = useRef(null);
  useImperativeHandle(ref, () => ({
    update(frame) {
      const el = element.current;
      if (!el) return;
      if (!frame) { el.style.display = "none"; return; }
      el.style.display = "block";
      el.style.setProperty("--reveal-opacity", frame.fullscreen);
      el.style.setProperty("--content-opacity", frame.content);
      for (const key of ["dive", "background", "fullscreen", "content"]) {
        el.dataset[key] = frame[key].toFixed(3);
      }
      for (const key of ["left", "top", "width", "height", "stageWidth", "stageHeight"]) {
        el.dataset[key] = frame[key];
      }
    },
  }), []);
  return (
    <Window ref={element} data-testid="hotseat-screen-reveal" aria-hidden="true">
      <div className="content">
        {winner && <HotSeatWinnerContent winner={winner} showWinner={showWinner} />}
      </div>
    </Window>
  );
});
